function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".my-newport_svg__cls-1{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:.5px}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "my-newport_svg__cls-1",
  cx: 5.85,
  cy: 3.346,
  r: 3.199
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "my-newport_svg__cls-1",
  d: "M.146 11.553v-.98A2.314 2.314 0 012.46 8.258h6.78a2.314 2.314 0 012.314 2.315v.98"
});

function SvgMyNewport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-newport_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMyNewport;